const isProduction = process.env.NODE_ENV === 'production';
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export const Analytics = {
  pageView: (pageName, pagePath) => {
    if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID.startsWith('G-')) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: pagePath,
        page_title: pageName
      });
    }
  },

  event: (eventName, eventData = {}) => {
    if (typeof window !== 'undefined' &&
        window.gtag &&
        GA_MEASUREMENT_ID.startsWith('G-')) {
      window.gtag('event', eventName, {
        ...eventData,
        timestamp: new Date().toISOString()
      });
    }
  },

  productView: (product) => {
    Analytics.event('view_item', {
      currency: 'KES',
      value: product.price,
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_brand: product.brand,
        price: product.price
      }]
    });
  },

  addToCart: (product, quantity = 1) => {
    Analytics.event('add_to_cart', {
      currency: 'KES',
      value: product.price * quantity,
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_brand: product.brand,
        price: product.price,
        quantity
      }]
    });
  },

  removeFromCart: (product) => {
    Analytics.event('remove_from_cart', {
      currency: 'KES',
      value: product.price,
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_brand: product.brand,
        price: product.price
      }]
    });
  },

  beginCheckout: (cartItems, total) => {
    Analytics.event('begin_checkout', {
      currency: 'KES',
      value: total,
      items: cartItems.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_brand: item.brand,
        price: item.price,
        quantity: item.quantity
      }))
    });
  },

  purchase: (orderId, total, items) => {
    Analytics.event('purchase', {
      transaction_id: orderId,
      currency: 'KES',
      value: total,
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_brand: item.brand,
        price: item.price,
        quantity: item.quantity
      }))
    });
  },

  search: (searchTerm, resultsCount) => {
    Analytics.event('search', {
      search_term: searchTerm,
      results: resultsCount
    });
  },

  wishlistAdd: (product) => {
    Analytics.event('add_to_wishlist', {
      currency: 'KES',
      value: product.price,
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_brand: product.brand,
        price: product.price
      }]
    });
  },

  error: (errorMessage, errorStack) => {
    Analytics.event('exception', {
      description: errorMessage,
      fatal: false
    });
    if (!isProduction) {
      console.error('[Analytics] Error:', errorMessage, errorStack);
    }
  },

  timing: (category, variable, value, label) => {
    Analytics.event('timing_complete', {
      name: variable,
      value: value,
      event_category: category,
      event_label: label
    });
  }
};

export default Analytics;